import { SatellitePage } from "./SatellitePage";
import HomeSatellitePage from "./pages/HomeSatellitePage";
import InnovationSatellitePage from "./pages/InnovationSatellitePage";
import ScenesSatellitePage from "./pages/ScenesSatellitePage";
import BuildingSatellitePage from "./pages/BuildingSatellitePage";
import PricesSatellitePage from "./pages/PricesSatellitePage";
import OrderSatellitePage from "./pages/OrderSatellitePage";

export default class Satellite {
    private $el: JQuery;

    private $menu: JQuery;
    private $menuitems: JQuery;

    private $pagerno: JQuery;
    private $pageritems: JQuery;
    private $pagertitle: JQuery;

    private $pageswrap: JQuery;
    private $pages: JQuery;

    private curpage: number;

    private pages: SatellitePage[];

    public constructor () {
        this.pages = [];
    }

    public getPage(name: string): SatellitePage {
        let result = null;

        $.each(this.pages, (ix, page) => {
            const pn = page.getName();

            if (pn == name) {
                result = page;
                return true;
            }
        });

        if (result == null) {
            throw 'Page not found: ' + name;
        }

        return result;
    }

    public setPage(page: SatellitePage, force?: boolean): void {
        const ix = page.getIndex();

        $('body').removeClass('vsatellite--opened');

        if (this.curpage == ix) {
            return;
        }

        const prevpage = this.pages[this.curpage];

        const vh = window.innerHeight;

        const $pageritem = this.$pageritems.eq(ix);
        this.$pageritems.not($pageritem).removeClass('vsatellite__pager-item--selected');
        $pageritem.addClass('vsatellite__pager-item--selected')

        const $menuitem = this.$menuitems.filter('[data-name="' + page.getName() + '"]');
        this.$menuitems.not($menuitem).removeClass('satellite-menu__item--selected');
        $menuitem.addClass('satellite-menu__item--selected')

        this.$pagerno.text((ix + 1) + '/' + this.pages.length);

        this.$pagertitle.text(page.getTitle());

        if (force) {
            this.$pageswrap.addClass('vsatellite__pages--force');
        }

        this.$pageswrap.css({
            'top': -ix * vh
        });

        if (force) {
            this.$pageswrap[0].offsetHeight;
            this.$pageswrap.removeClass('vsatellite__pages--force');
        }

        this.curpage = ix;

        if (prevpage != null) {
            prevpage.onBlur();
        }

        page.onFocus();
    }

    public nextPage(): void {
        let ix = this.curpage + 1;

        if (ix >= this.pages.length) {
            ix = this.pages.length - 1;
        }

        this.setPage(this.pages[ix]);
    }

    public prevPage(): void {
        let ix = this.curpage - 1;

        if (ix < 0) {
            ix = 0;
        }

        this.setPage(this.pages[ix]);
    }

    public updateLayout(): void {
        const vw = window.innerWidth;
        const vh = window.innerHeight;

        $.each(this.pages, (ix, page) => {
            const $page = page.getEl();

            $page.css({
                'height': vh,
                'top':  ix * vh
            });
        });

        this.$pageswrap.addClass('vsatellite__pages--force');

        this.$pageswrap.css({
            'top': -this.curpage * vh
        });

        this.$pageswrap[0].offsetHeight;
        this.$pageswrap.removeClass('vsatellite__pages--force');

        this.$menu.toggleClass('satellite-menu--mobile', vw <= 1024);
        this.$menu.toggleClass('satellite-menu--desktop', vw > 1024);
    }

    private initNavi(): void {
        const This = this;

        this.$menu = $('.satellite-menu', this.$el);
        this.$menuitems = $('.satellite-menu__item', this.$menu);

        this.$menuitems.each((ix, el) => {
            const $el = $(el);
            const name = $el.data('name');

            $el.on('click', (e) => {
                e.preventDefault();

                this.setPage(this.getPage(name));
            });
        });

        this.$pagerno = $('.vsatellite__page-no', this.$el);
        this.$pagertitle = $('.vsatellite__page-title span', this.$el);

        const $pager = $('.vsatellite__pager', this.$el);

        $.each(this.pages, (ix, page) => {
            const $p = $('<span class="vsatellite__pager-item">');

            $p.on('click', () => {
                this.setPage(page);
            });

            $p.appendTo($pager);
        });

        this.$pageritems = $('.vsatellite__pager-item', $pager);

        $('.vsatellite__page-nav-up').click(() => {
            this.prevPage();
        });

        $('.vsatellite__page-nav-down').click(() => {
            this.nextPage();
        });

        $('.js-satellite-page').on('click', function () {
            const page = This.getPage($(this).data('name'));

            This.setPage(page);
        });

        $('.satellite-menu__button', this.$menu).on('click', (e) => {
            $('body').toggleClass('vsatellite--opened');
        });
    }

    private initPages(): void {
        this.$pageswrap = $('.vsatellite__pages', this.$el);
        this.$pages = $('.vsatellite__page', this.$el);

        this.$pages.each((ix, el) => {
            const $el = $(el);

            const name = $el.data('name');
            let page = null;

            switch (name) {
                case 'home':
                    page = new HomeSatellitePage(ix, $el);
                    break;

                case 'innovation':
                    page = new InnovationSatellitePage(ix, $el);
                    break;

                case 'scenes':
                    page = new ScenesSatellitePage(ix, $el);
                    break;

                case 'building':
                    page = new BuildingSatellitePage(ix, $el);
                    break;

                case 'prices':
                    page = new PricesSatellitePage(ix, $el);
                    break;

                case 'order':
                    page = new OrderSatellitePage(ix, $el);
                    break;

                default:
                    page = new SatellitePage(ix, $el);
            }

            this.pages.push(page);
        });
    }

    public initHtml(): void {
        this.$el = $('.vsatellite');

        this.initPages();
        this.initNavi();

        $(window).on('resize scroll', () => {
            this.updateLayout();
        });

        this.updateLayout();

        $.each(this.pages, (ix, page) => {
            page.onInit();
        });

        $(window).on('load', () => {
            this.setPage(this.getPage('home'), true);

            this.$el.addClass('vsatellite--loaded');
        });
    }
}
